<script>
</script>

<span class="provi-badge light-small--bold">
  <slot />
</span>
